import React from "react";
import MsbtePogramPageSection from "../../Sections/MsbtePogramPageSection/Content";
const MSBTEProgramPage = () => {
  return <MsbtePogramPageSection />;
};

export default MSBTEProgramPage;
